'use strict';
angular.module('onlineSearchModule', [])
    .directive('onlineSearch', ['$timeout', 'trsHttpService', 'alterModule', 'modalDialog', function ($timeout, trsHttpService, alterModule, modalDialog) {
        return {
            replace: true,
            restrict: 'E',
            transclude: false,
            templateUrl: './editingCenter/directive/supportCreation/onlineSearch/onlineSearch_tpl.html',
            scope: false,
            link: function (scope, $elem, $attrs) {
                initStatus();

                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        page: {
                            'CURRPAGE': 1,
                            'PAGESIZE': 20,
                            'ITEMCOUNT': 0,
                            'PAGECOUNT': 1
                        },
                        tabList: [{ name: '百度新闻', value: 'bdsearch' },
                            { name: '微信公众号', value: 'weixinsearch' },
                            // { name: '微博', value: 'weibosearch' }
                        ],
                        selectedTab: { name: '百度新闻', value: 'bdsearch' },
                        keyword: '',
                        isLast: false,
                    };
                    scope.data = {
                        result: []
                    };
                }

                /**
                 * [resultFormat description] 搜索结果格式化
                 * @param  {[type]} result [description] 搜索结果数据
                 * @return {[type]}        [description]
                 */
                function resultFormat(result) {
                    let reg = new RegExp(scope.status.keyword, 'g');
                    if (scope.status.selectedTab.value == 'bdsearch') {
                        result = result.map((_item) => {
                            _item.bdTitleFormat = _item.bdTitle.replace(reg, `<span>${scope.status.keyword}</span>`);
                            _item.bdDescFormat = _item.bdDesc.replace(reg, `<span>${scope.status.keyword}</span>`);
                            return _item;
                        });
                    } else if (scope.status.selectedTab.value == 'weixinsearch') {
                        result = result.map((_item) => {
                            _item.sgwxTitleFormat = _item.sgwxTitle.replace(reg, `<span>${scope.status.keyword}</span>`);
                            _item.sgwxDescFormat = _item.sgwxDesc.replace(reg, `<span>${scope.status.keyword}</span>`);
                            return _item;
                        });
                    } else if (scope.status.selectedTab.value == 'weibosearch') {
                        result = result.map((_item) => {
                            _item.weiboDescFormat = _item.weiboDesc.replace(reg, `<span>${scope.status.keyword}</span>`);
                            _item.picArray = _item.weiboPicLinks.split(';');
                            for (var i = 0; i < _item.picArray.length - 1; i++) {
                                _item.picArray[i] = 'https:' + _item.picArray[i];
                            }
                            return _item;
                        });
                    }
                    return result;
                }

                /**
                 * [selectTab description] tab切换
                 * @param  {[type]} tab [description] 选择的tab
                 * @return {[type]}     [description]
                 */
                scope.selectTab = function (tab) {
                    if (scope.status.selectedTab.value == tab.value) {
                        return;
                    }
                    scope.status.selectedTab = tab;
                    scope.data.result = [];
                    scope.status.page.CURRPAGE = 1;
                    scope.status.keyword = '';
                    scope.status.isLast = false;
                };

                /**
                 * [search description] 搜索
                 * @param  {[type]} ev [description] event
                 * @return {[type]}    [description]
                 */
                scope.search = function (isNew, ev) {
                    if ((angular.isUndefined(ev) || (angular.isDefined(ev) && ev.keyCode == 13)) && scope.status.keyword != '') {
                        let params = {
                            keyword: scope.status.keyword,
                            page_no: (scope.status.page.CURRPAGE - 1),
                            pagesize: scope.status.page.PAGESIZE,
                        };
                        scope.loadingPromise = trsHttpService.httpServer('/metasearch/customSentimentSearch/' + scope.status.selectedTab.value, params, 'get').then((data) => {
                            if (data.issuccess == 'true') {
                                if (data.data.length < scope.status.page.PAGESIZE) {
                                    scope.status.isLast = true;
                                }
                                scope.data.result = isNew ? resultFormat([].concat(data.data)) : resultFormat(scope.data.result.concat(data.data));
                            } else {
                                modalDialog.alertType('', data.msg, 'error', false);
                            }
                        });
                    }
                };

                /**
                 * [loadMore description] 加载更多
                 * @return {[type]} [description]
                 */
                scope.loadMore = function () {
                    if (!scope.status.isLast) {
                        scope.status.page.CURRPAGE++;
                        scope.search();
                    }
                };
            }
        };
    }]);
